module.exports = __webpack_public_path__ + "static/media/bagy4.d0be4b8c.png";